import { Injectable } from '@angular/core';
import { ARMAuthService } from './arm-auth.service';
import { PermissionsService } from 'ag-common-svc/lib/services/permissions.service';

/**
 * The CRM's permission source.
 *
 * It used to re-run the same role-folding logic ARMAuthService already ran — a
 * second copy of a merge that also existed in two portal services — and without a
 * `shareReplay`, so every subscriber re-computed it and re-subscribed upstream.
 * Now it simply exposes the map the server already merged.
 */
@Injectable()
export class ARMPermissionsService extends PermissionsService {
  constructor(armAuthService: ARMAuthService) {
    super();

    this.permissions$ = armAuthService.armPermissions$;
  }
}
